module.exports = __webpack_public_path__ + "img/apply.1d7d7d16.png";